//GeneratorFlag:[NoChange]
import Letter from './letter';
import Branch from './branch';
import StaticFile from './static-file';

export default {Letter, Branch, StaticFile}
export{Letter, Branch, StaticFile}